import Loading, { LoadingProps as _LoadingProps } from './Loading';

export { Loading };
export type LoadingProps = _LoadingProps;
